<template>
  <div v-if="templateType === 'chip'">
    <v-chip 
      v-if="roleKey === '0'" 
      color="cyan" dark x-small
    >{{ "lng_dealer_txt" | translate }}</v-chip>
    <v-chip 
      v-else-if="roleKey === '1'" 
      color="pink" dark x-small
    >{{ "lng_end_user_txt" | translate }}</v-chip>
    <!-- <v-chip 
      v-else-if="roleKey === '2'" 
      color="brown" dark x-small
    >{{ "lng_multiuser_txt" | translate }}</v-chip> -->
    <v-chip 
      v-else-if="roleKey === '3'" 
      color="green" dark x-small
    >{{ "lng_admin_txt" | translate }}</v-chip>
  </div>
  
  <div v-else-if="templateType === 'badge'">
    <v-badge
      v-if="roleKey === '0'" 
      color="cyan" content="d"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '1'" 
      color="pink" content="u"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '2'" 
      color="brown" content="m"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '3'" 
      color="green" content="a"
    ></v-badge>
  </div>  
</template>

<script>
export default {
  name: "UserRoles",
  props:{
    roleKey: {
      type: String,
      default: ""
    },
    templateType: {
      type: String,
      default: "chip"
    }
  }
}
</script>